import { useContext } from "react";

import AllPhotoUploadsContext from "../context/AllPhotoUploadsContext";

const useUploadsCurrentlyProcessing = () => {
    const context = useContext(AllPhotoUploadsContext);

    if (context === undefined) {
        throw new Error(
            "usePhotoUploadsInDropzone must be used within an AllPhotoUploadsProvider"
        );
    }

    const { currentlyProcessing, setCurrentlyProcessing } = context;

    const addToCurrentlyProcessing = (filenames = []) => {
        if (!filenames.length) return;

        const newlyProcessing = [];

        filenames.forEach(filename => {
            if (!currentlyProcessing.includes(filename)) {
                newlyProcessing.push(filename);
            }
        });

        setCurrentlyProcessing(prevState => [...prevState, ...newlyProcessing]);
    };

    const removeFromCurrentlyProcessing = (filenames = []) => {
        if (!filenames.length) return;

        let updatedCurrentlyProcessing = [...currentlyProcessing];

        filenames.forEach(filenameToRemove => {
            updatedCurrentlyProcessing = updatedCurrentlyProcessing.filter(
                filename => filename !== filenameToRemove
            );
        });

        setCurrentlyProcessing(updatedCurrentlyProcessing);
    };

    return {
        count: currentlyProcessing.length || 0,
        addToCurrentlyProcessing,
        removeFromCurrentlyProcessing
    };
};

export default useUploadsCurrentlyProcessing;
